import { Injectable, inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { ROLES } from '../constants/user.const';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private roles!: Array<string>;
  private keycloakService = inject(KeycloakService);

  public init(): void {
    this.roles = this.keycloakService.getUserRoles();
  }

  public getRoles(): Array<string> {
    return this.roles;
  }

  public checkPermissions(roles: Array<ROLES>): boolean {
    return roles.some((role) => this.roles.indexOf(role) > -1);
  }
}
